import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnDestroy
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { KngButton, KngButtonState } from './definitions';
import { KngButtonFactory } from './kng-button.factory';

const svgIconName: string = 'icon-input';

@Component({
	selector: 'kng-button',
	templateUrl: './template/kng-button.component.html',
	styleUrls: ['./template/kng-button.component.scss']
})
export class KngButtonComponent implements KngButton, OnDestroy 
{
	private subscription$: Subscription = new Subscription();

	private readonly pSvgIconName: string = svgIconName;
	get svgIconName(): string 
	{
		return this.pSvgIconName;
	}

	private state$: BehaviorSubject<KngButtonState> =
		new BehaviorSubject<KngButtonState>(KngButtonFactory.build());
	get state(): KngButtonState 
	{
		return this.state$.value;
	}
  @Input() set state(value: KngButtonState) 
	{
		this.state$.next(value);
	}
  @Output() clicked: EventEmitter<KngButtonState> =
  	new EventEmitter<KngButtonState>();

  ngOnDestroy(): void 
  {
  	this.subscription$.unsubscribe();
  }
  public handleClick() 
  {
  	this.clicked.emit(this.state);
  }
}
